import { Point, PointList } from '@/models/point/list/point'
import { PointService } from '@/services/point'
import { Either } from 'fp-ts/lib/Either'

export interface PointListRepository {
  list(): Promise<Either<Error, PointList>>
}

export class ApiPointListRepository implements PointListRepository {
  constructor(private readonly client: PointService) { }

  async list(): Promise<Either<Error, PointList>> {
    const result = await this.client.getAggregated({
      order_key: 'last_available_at',
      order_direction: 'asc',
    })

    return result.map(response =>
      PointList.valueOf(
        response.map(
          r => new Point(
            r.point,
            new Date(
              Date.parse(r.last_available_at)
            )
          )
        )
      )
    )
  }
}
